module.exports = __webpack_public_path__ + "img/ring_g_o_0_null.bdbccd66.png";